/** A terracotta pot of flowers (lantern-water `world.js` `pot`). Params: `scale` (0.6). */
import * as THREE from 'three';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'planter',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    ctx.pot(root, 0, 0, 0, num(ctx, 'scale', 0.6));
    return { root };
  },
};
